// Card is the existing generic CARD option; Bit is independently opt-in.
function isKesherBitEnabled(org, assoc, currency) {
    return (
        String(currency).toLowerCase() === 'ils' &&
        Array.isArray(org?.config) &&
        org.config.some(
            (item) =>
                item.key === 'KESHER.BIT_PAIEMENT_METHOD' &&
                item.organisation === org.id &&
                item.assoc === assoc &&
                item.enabled !== false
        )
    )
}
module.exports = { isKesherBitEnabled }
